import CloseIcon from '@mui/icons-material/Close';
import {
  Alert, Button, Fade, Grow, IconButton, Slide, useTheme,
} from '@mui/material';
import MuiSnackbar from '@mui/material/Snackbar';
import { useDispatch, useSelector } from 'react-redux';

import { snackbarClose } from 'store/snackbarSlice';

function TransitionSlideLeft(props) {
  return <Slide {...props} direction="left" />;
}

function TransitionSlideUp(props) {
  return <Slide {...props} direction="up" />;
}

function TransitionSlideRight(props) {
  return <Slide {...props} direction="right" />;
}

function TransitionSlideDown(props) {
  return <Slide {...props} direction="down" />;
}

function GrowTransition(props) {
  return <Grow {...props} />;
}

function FadTransition(props) {
  return <Fade {...props} />;
}

const transition = {
  SlideLeft: TransitionSlideLeft,
  SlideUp: TransitionSlideUp,
  SlideRight: TransitionSlideRight,
  SlideDown: TransitionSlideDown,
  Grow: GrowTransition,
  Fade: FadTransition
};

const AUTO_HIDE_MS = 4000;

const Snackbar = () => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const snackbar = useSelector((state) => state.snackbar);

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatch(snackbarClose());
  };

  return (
    <>
      {/* default snackbar */}
      {snackbar.variant === 'default' && (
        <MuiSnackbar
          anchorOrigin={snackbar.anchorOrigin}
          open={snackbar.open}
          autoHideDuration={AUTO_HIDE_MS}
          onClose={handleClose}
          message={snackbar.message}
          TransitionComponent={transition[snackbar.transition]}
          action={(
            <>
              <Button color="secondary" size="small" onClick={handleClose}>
                UNDO
              </Button>
              <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </>
          )}
        />
      )}

      {/* alert snackbar */}
      {snackbar.variant === 'alert' && (
        <MuiSnackbar
          TransitionComponent={transition[snackbar.transition]}
          anchorOrigin={snackbar.anchorOrigin}
          open={snackbar.open}
          autoHideDuration={AUTO_HIDE_MS}
          onClose={handleClose}>
          <Alert
            variant="filled"
            severity={snackbar.alertSeverity}
            sx={{
              bgcolor: `${snackbar.alertSeverity}.dark`,
              color: snackbar.alertSeverity === 'warning' ? theme.palette.grey[800] : 'white',
            }}
            action={(
              <>
                {snackbar.actionButton !== false && (
                  <Button color="secondary" size="small" onClick={handleClose}>
                    UNDO
                  </Button>
                )}
                {snackbar.close !== false && (
                  <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
              </>
            )}
          >
            {snackbar.message}
          </Alert>
        </MuiSnackbar>
      )}
    </>
  );
};

export default Snackbar;
